import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		titleWrapper: {
			marginBottom: theme.spacing(3.5),
			width: '100%',

			[theme.breakpoints.down('sm')]: {
				marginBottom: theme.spacing(5),
			},
		},

		title: {
			textAlign: 'left',

			[theme.breakpoints.down('sm')]: {
				'& *': {
					textAlign: ({ metaData }) =>
						metaData.mobileAlignment?.metaValue ? `${metaData.mobileAlignment.metaValue} !important` : null,
				},
			},
		},

		container: {
			height: '100%',
			width: '100%',
		},

		listContainer: {
			width: '100%,',
			[theme.breakpoints.up('md')]: {
				display: 'flex',
				flexDirection: 'column',
				width: 'calc(100% + 4px)',
				height: 'calc(100% + 4px)',
			},
		},

		list: {
			width: '100%',
			[theme.breakpoints.up('md')]: {
				height: theme.spacing(40),
				flexGrow: 1,
				padding: 2,
				overflow: 'hidden',
				overflowY: 'auto',
			},
		},
	}),
	{ name: 'Video-Video9' },
)

export default useStyles
